import { useMutation } from 'react-query';

import { VeriffSessionParams, createVeriffSession } from '@utils/backend-api/veriff';

export default function useCreateSession() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: VeriffSessionParams) => createVeriffSession(params),
    {
      onError: (error: { message: string }) => {
        console.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
